






















import { plainToInstance } from "class-transformer";
import { Vue, Component, Prop } from 'vue-property-decorator';

import MediaItem from "./NewMessageEditors/NewMessageEditorWithMedia/Media/components/MediaList/MediaItem.vue";
import { MediaFileData } from "./NewMessageEditors/NewMessageEditorWithMedia/Media/logic/MediaFileData";
import MediaManager from "./NewMessageEditors/NewMessageEditorWithMedia/Media/logic/MediaManager";
import {
  MessageAttachment,
  MessageMedia
} from "./NewMessageEditors/NewMessageEditorWithMedia/Media/types";
import { MediaEditorMode } from "./NewMessageEditors/types";

@Component({
  components: {
    MediaItem
  }
})
export default class PlainMediaList extends Vue {
  @Prop() attachments!: MessageMedia['attachments']

  @Prop() targetToUpload!: { target: string, target_id: string | number }

  mediaManager: MediaManager | null = null

  get attachmentInstances() {
    return plainToInstance(MessageAttachment, this.attachments).map(a => new MediaFileData(a))
  }

  created() {
    this.mediaManager = new MediaManager([], this.targetToUpload, MediaEditorMode.TelegramBase, this.$i18n, undefined)
  }
}
